module.exports = __webpack_public_path__ + "img/dosen-tooltip.png";